"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.createMuiBackdropOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            backgroundColor: styles_1.fade(palette.common.black, 0.72),
        },
    });
};
//# sourceMappingURL=MuiBackdrop.js.map